import { useState, useEffect, useRef } from 'react'
import { Box, Collapse } from '@mui/material'
import styles from './Notices.module.scss'
import SanitizeHtml from '../Base/SanitizeHtml/SanitizeHtml'

const ImportantNoticesDesktop = () => {
  const { title, number, records } = window.noticeData
  const [isOpen, setIsOpen] = useState(false)
  const noticeRef = useRef(null)

  const [windowWidth, setWindowWidth] = useState(window.innerWidth)

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    // Function to handle clicks outside the component
    const handleClickOutside = (event) => {
      if (
        noticeRef.current &&
        !noticeRef.current.contains(event.target) &&
        isOpen
      ) {
        // Add a small delay before closing
        setTimeout(() => {
          setIsOpen(false)
        }, 100)
      }
    }

    // Function to handle swiper click events
    const handleSwiperClick = () => {
      if (isOpen) {
        setIsOpen(false)
      }
    }

    // Add event listeners
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    // Always listen for the custom onClickSwiper event
    document.addEventListener('onClickSwiper', handleSwiperClick)

    // Clean up the event listeners
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('onClickSwiper', handleSwiperClick)
    }
  }, [isOpen])

  const toggleExpand = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className={styles.notice__block} ref={noticeRef}>
      <div className={styles.notice__main__and__secondary}>
        <div className={styles.main__block}>
          <div className={styles.number}>
            <span>{records.length}</span>
          </div>
          <button
            className={`btn ${styles.btn}`}
            type="button"
            id="ImportantNoticesExpand"
            onClick={toggleExpand}
            aria-expanded={isOpen}
            aria-label="Toggle important notices">
            {title}
            <i
              className={`icon-arrow-down arrow ${styles.arrow} ${
                isOpen ? styles.rotate : ''
              }`}
              aria-hidden="true"
            />
          </button>
        </div>

        <Collapse in={isOpen}>
          <Box className={styles.notice__content}>
            <div className={styles.notice__expand}>
              <article className="b-article">
                {records.map((record, index) => (
                  <div key={index} className={styles.noteCard}>
                    <i
                      className="icon-info"
                      style={{ fontSize: '20px', marginRight: '15px' }}></i>
                    <SanitizeHtml html={record.text} />
                  </div>
                ))}
              </article>
            </div>
          </Box>
        </Collapse>
      </div>
    </div>
  )
}

export default ImportantNoticesDesktop
